import { DiReact } from "react-icons/di";
import { TbBrandRedux } from "react-icons/tb";
import html from "../images/icons/html.png";
import css from "../images/icons/css.png";
import js from "../images/icons/js.png";
import bootstrap from "../images/icons/bootstrap.png";
import mui from "../images/icons/mui.png";
import flutter from "../images/icons/flutter.png";
import python from "../images/icons/python.svg";
import mysql from "../images/icons/mysql.svg";
import firebase from "../images/icons/firebase.svg";
import git from "../images/icons/git.png";
import github from "../images/icons/github.png";
import netlify from "../images/icons/netlify.png";
import vscode from "../images/icons/vscode.png";
import postman from "../images/icons/postman.svg";
import figma from "../images/icons/figma.png";
import docker from "../images/icons/docker.svg";
import slack from "../images/icons/slack.png";
import trello from "../images/icons/trello.png";
import notion from "../images/icons/notion.png";
import plusTwo from "../images/icons/plus2.png";
import texas from "../images/icons/texas.webp";
import softonic from "../images/icons/softechtonic.webp";
import rpre from "../images/icons/rpre.jpeg";
import resume from "../images/resume.pdf";
import palmrealestate from "../images/icons/palmrealestate.webp";
import hostelhero from "../images/icons/hostelhero.webp";
import votingapp from "../images/icons/voting.webp";
import camcricket from "../images/icons/camcricket.webp";
import palmrealestate1 from "../images/icons/palm.webp";
import votingapp1 from "../images/icons/voting1.webp";
import hostelhero1 from "../images/icons/hostel1.webp";
import camcricket1 from "../images/icons/cam.webp";



export const Bio = {
  name: "Rajiv Shrestha",
  roles: [
    "Flutter Developer",
    "Mobile App Developer",
    "Programmer",
  ],
  description:
    "I am a creative problem-solver with a passion for innovation and a relentless drive for excellence. Eager to embrace new challenges, I thrive in dynamic environments where I can leverage my diverse skills to deliver impactful solutions. I believe in the power of continuous learning and adaptability, always seeking out opportunities to grow and evolve.",
  github: "https://github.com/rajivstha10",
  resume: resume,
  linkedin: "https://www.linkedin.com/in/raziv1/",
  // twitter: "https://twitter.com/RishavChanda",
  insta: "https://www.instagram.com/raziv_1/",
  facebook: "https://www.facebook.com/rajiv.shrestha.5015983",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: html,
      },
      {
        name: "CSS",
        image: css,
      },
      {
        name: "JavaScript",
        image: js,
      },
      {
        name: "Bootstrap",
        image: bootstrap,
      },
      {
        name: "Material UI",
        image: mui,
      },
      {
        name: "Flutter",
        image: flutter,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Python",
        image: python,
      },
      {
        name: "MySQL",
        image: mysql,
      },
      {
        name: "Firebase",
        image: firebase,
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: git,
      },
      {
        name: "GitHub",
        image: github,
      },
      {
        name: "Docker",
        image: docker,
      },
      {
        name: "Netlify",
        image: netlify,
      },
      {
        name: "VS Code",
        image: vscode,
      },
      {
        name: "Postman",
        image: postman,
      },
      {
        name: "Figma",
        image: figma,
      },
      {
        name: "Slack",
        image: slack,
      },
      {
        name: "Trello",
        image: trello,
      },
      {
        name: "Notion",
        image: notion,
      },

    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: rpre,
    role: "Flutter Developer",
    company: "RPRE Tech Studio",
    date: "Aug 2026 - Present",
    desc: "Developing cross-platform mobile applications using Flutter, focusing on building high-performance, scalable, and visually engaging solutions. Collaborating with the team to deliver polished apps with clean architecture and modern design patterns.",
    skills: [
      "Flutter",
      "Dart",
      "Firebase",
      "RESTful APIs",
      "State Management (Provider, Bloc)",
      "Git & Version Control",
      "UI/UX Design Principles",
    ],
  },
  {
    id: 1,
    img: softonic,
    role: "Flutter Developer",
    company: "Softech Tonic Pvt Ltd.",
    date: "Oct 2023 - Aug 2026",
    desc: "Working on mobile app development with a focus on Flutter, building seamless cross-platform applications with robust performance and engaging user experiences. Skilled in leveraging the latest tools and technologies to create high-quality, scalable solutions.",
    skills: [
      "Flutter",
      "Dart",
      "Firebase",
      "RESTful APIs",
      "JSON",
      "State Management (Provider, Bloc)",
      "Git & Version Control",
      "UI/UX Design Principles",
    ],
  },
  {
    id: 2,
    img: softonic,
    role: "QA Intern",
    company: "Softech Tonic Pvt Ltd.",
    date: "Dec 2022 - Aug 2023",
    desc: "Experienced in ensuring the highest quality standards for software products, with a strong focus on test automation and process optimization. Passionate about delivering bug-free, user-centric applications through rigorous testing and continuous improvement.",
    skills: [
      "Manual Testing",
      "Automated Testing (Selenium)",
      "Bug Tracking (JIRA)",
      "API Testing (Postman)",
      "Test Planning and Strategy",
      "Performance Testing (LoadRunner)",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: texas,
    school: "Texas College of Management and IT",
    date: "2021 - 2024",
    grade: "3.61 CGPA",
    desc: "I have completed a Bachelor's degree in Information Technology at Texas College of Management and IT, Kathmandu. I have completed my Bachelor's degree with a CGPA of 3.61. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Information Technology(BIT)",
  },
  {
    id: 1,
    img: plusTwo,
    school: "St. Lawrence",
    date: "2018 - 2020",
    grade: "3.02 CGPA",
    desc: "I completed my class 12 high school education at St. Lawrence, Kathmandu, where I studied IT with Computer Science.",
    degree: "Computer Science",
  },
];

export const projects = [
  {
    id: 0,
    title: "Cam Cricket",
    date: "Nov 2023 - Jun 2024",
    description: "Used WebSocket and packages like Go-Router, Provider, Dio. Built a cross-platform application for online scoring and live match viewing for the CAM Premier League.",
    image: [camcricket, camcricket1],
    tags: [
      "Flutter",
      "WebSockets",
      "Dart",
      "Dio",
      "Firebase",
      "JSON",
      "RESTful APIs",
      "Bloc",
    ],
    category: "completed",
    // github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://play.google.com/store/apps/details?id=com.softechtonic.cam_cricket&hl=en&gl=US",
    // member: [
    //   {
    //     name: "Rajiv Shrestha",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rajiv-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 9,
    title: "Palm Real Estate",
    date: "May 2024 ",
    description: "Used Custom Painter, Flutter Maps, and many more widgets. Built a cross-platform application for Real Estate that calculates the area of land via Geo Plotter and custom plotter.",
    image: [palmrealestate, palmrealestate1],
    tags: [
      "Flutter",
      "Dart",
      "Custom Painter",
      "Flutter Maps",
      "Dio",
      "Firebase",
      "Bloc",
    ],
    category: "ongoing",
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 1,
    title: "Hostel Hero",
    date: "Oct 2022 - Present",
    description: "A mobile application that monitors and manages the routines of students living in a hostel.Used packages like qrScanner, HTTP, and Firebase to manage student data.",
    image: [hostelhero, hostelhero1],
    tags: [
      "Flutter",
      "Dart",
      "QR Flutter",
      "Table Calendar",
      "HTTP",
      "Firebase",
      "JSON",
    ],
    category: "completed",
    github: "https://github.com/rajivstha10/hostelhero",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Voting App",
    date: "Jun 2024 - Jun 2024",
    description:
      "A mobile application that uses Firebase as the core backend and updates vote counts in real-time.Utilizes StreamBuilder to show real-time changes in vote counts after every vote.",
    image: [votingapp, votingapp1],
    tags: [
      "Flutter",
      "Dart",
      "Firebase",
      "JSON",
      "Go Router",
      "Gap",
      "Cupertino Icons",
    ],
    category: "completed",
    github: "https://github.com/rajivstha10/votingApp",
    // webapp: "https://brain-tumor.netlify.app/",
    // member: [
    //   {
    //     name: "Rajiv Shrestha",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rajiv-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
  //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  // },
  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
